/* Ott-common */
import RemainingTime from '@dtvgo/remaining-time';

/* Utils */
import { withClassName } from '../../../../hocs/withClassName.hoc';
import { ProgressBarContainerClassNames } from './utils';

export default withClassName(ProgressBarContainerClassNames.element('remaining-time'))(RemainingTime);
